module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-21.f1b9e2c0.jpg";